module.exports = __webpack_public_path__ + "img/swiss-eco-bags-2.ebe5b584.jpg";